import React from 'react';
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, message, Button, Divider,Select} from 'antd';
import {  getCustomList } from "../../model/customs/requests";
import {  BindCustom } from "../../model/group/requests";
import { route } from '../../routes/routes';
import storage from '../../utils/storage';
import { configs } from '../../config/config';

import {dbFields}  from '../../model/customs/column';
export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const Option = Select.Option;


class GroupCustom extends React.Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            customList:[],
            customIds:[]
        }
    };

    componentDidMount(){
        let customList = [];
        getCustomList().then(res=>{
            if(res.data.code == 200){
                customList = res.data.data
                this.setState({
                    customList:customList
                })
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })
    }

    handlerSubmit = (e)=>{
        let groupId = parseInt(this.props.match.params.id);
        let customIds = this.state.customIds;
        let custom_id = customIds.join(",")
       BindCustom({group_id:groupId,custom_id:custom_id}).then(res=>{
        if(res.data.code == 200){
            message.success("group binding custom success !");

            setTimeout(()=>{
                this.props.history.push(route.group.index)
            },1000)
        }else{
            message.error(res.data.msg)
        }
       }).catch(err=>{
            message.error(err)
       })

        return false;
    }

    handlerChange = (item) => {
        this.setState({
            customIds:item
        })
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    render(){
        const {customList} = this.state
        return (
            <>
              <BreadcrumbCustomer first='Group' second='Bind Custom' />
                <Divider />
                <Form
                    {...layout}
                    initialValues={{
                        remember: true,
                    }}
                    >
                    <Form.Item label={dbFields.name.title} name={dbFields.name.key}>
                        <Select 
                            mode='multiple'
                            onChange={this.handlerChange}
                        >
                            {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                    </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                                type="primary" 
                                style={{background: "#851dd6",color:"white" }}
                                onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>    
            
            </>

        )
    }


}
export default  GroupCustom;
